import { NavLink, useLocation } from 'react-router-dom'
import { useContext } from 'react'

import { projectContext, spaceRemover } from '../../lib'

import '../../styles/sideBar.scss'

export default function SideBarGenAI(props) {
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  let location = useLocation()
  let navigationLinks;

  if(props.project != undefined && !props.project){
    navigationLinks = [
      // {name: "Home", route: "/"},
      // {name: "Report", route: `/${spaceRemover(selectedProject.name)}/Report`},
      {name: "Settings", route: `/${spaceRemover(selectedProject.name)}/Settings`, active: props.active},
    ]
  }else{
    navigationLinks = [
      // {name: "Home", route: "/"},
      {name: "Project", route: `/${spaceRemover(selectedProject.name)}/GenAI`, active: props.active}, 
      {name: "Settings", route: `/${spaceRemover(selectedProject.name)}/SettingsGenAI`, active: props.active}, 
    ]
  }

  return (
    // <aside style={{height: 'fit-content', marginTop: "9%"}}>
    //   {/* <div className='icon bg-[#ffffff00]' style={{backgroundColor: "#ffffff00"}}></div> */}
    //   {navigationLinks.map(({name, route, active}, index) => {
    //     return (
    //       <NavLink to={route} key={index} className={ active === name ? "active" : "none"}>
    //         <img
    //           src={`/icons/${name}.png`}
    //           alt={name}
    //           // style={{minWidth: 10, width: 22}}
    //         />
    //         <p>{name}</p>
    //       </NavLink>
    //     )
    //   })}
    // </aside>


        <aside style={{height: 'fit-content', marginTop: "9%"}}>
      {/* <div className='icon bg-[#ffffff00]' style={{backgroundColor: "#ffffff00"}}></div> */}
      {navigationLinks.map(({name, route, active}, index) => {
        return (
          <NavLink to={route} key={index} className={ active === name ? "active" : "none"}>
            <img
              src={`/icons/${name}.png`}
              alt={name}
              // style={{minWidth: 10, width: 22}}
            />
            <p>{name}</p>
          </NavLink>
        )
      })}
    </aside>
  )
}
